module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on both jaws2.10c0776c.png";